var cov_1jylrws0n6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Spin/Simple.tsx",
      hash = "a1343c4f016f69ecd016913e85336120ab939594",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Spin/Simple.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 26
        },
        end: {
          line: 8,
          column: 46
        }
      },
      "1": {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "2": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 72
        }
      },
      "3": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "4": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 73
        }
      },
      "5": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "6": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 73
        }
      }
    },
    fnMap: {
      "0": {
        name: "Ring",
        decl: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 20
          }
        },
        loc: {
          start: {
            line: 7,
            column: 41
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "Plane",
        decl: {
          start: {
            line: 16,
            column: 16
          },
          end: {
            line: 16,
            column: 21
          }
        },
        loc: {
          start: {
            line: 16,
            column: 42
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "Pulse",
        decl: {
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 23,
            column: 21
          }
        },
        loc: {
          start: {
            line: 23,
            column: 42
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 23
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Spin/Simple.tsx";
import React from 'react';
import Spin from './Spin';
import { ringClass, planeClass, pulseClass } from './styles';
import { formatSize } from './util';
export function Ring(obj) {
  cov_1jylrws0n6.f[0]++;

  var _ref = (cov_1jylrws0n6.s[0]++, formatSize(obj.size)),
      value = _ref.value,
      unit = _ref.unit;

  var style = (cov_1jylrws0n6.s[1]++, {
    borderWidth: value / 10 + unit,
    borderTopColor: obj.color
  });
  cov_1jylrws0n6.s[2]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, obj, {
      count: 0,
      style: style,
      spinClass: ringClass,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 10
      }
    }))
  );
}
export function Plane(obj) {
  cov_1jylrws0n6.f[1]++;
  var style = (cov_1jylrws0n6.s[3]++, {
    backgroundColor: obj.color
  });
  cov_1jylrws0n6.s[4]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, obj, {
      count: 0,
      style: style,
      spinClass: planeClass,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 10
      }
    }))
  );
}
export function Pulse(obj) {
  cov_1jylrws0n6.f[2]++;
  var style = (cov_1jylrws0n6.s[5]++, {
    backgroundColor: obj.color
  });
  cov_1jylrws0n6.s[6]++;
  return (
    /*#__PURE__*/
    React.createElement(Spin, Object.assign({}, obj, {
      count: 0,
      style: style,
      spinClass: pulseClass,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 10
      }
    }))
  );
}